"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;

var _react = _interopRequireWildcard(require("react"));

var _atoms = require("../../atoms");

var _Util = require("../../Util");

require("./Notification.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Notification = function Notification(props) {
  var className = props.className;
  var componentClass = 'Notification';
  var children = props.children;

  if (className) {
    componentClass += ' ' + className;
  }

  if (props.open) {
    componentClass += ' open';
  }

  var attr = Object.assign({}, props, {
    className: null,
    open: null,
    children: null,
    hideNotification: null,
    setOpen: null
  });
  (0, _react.useEffect)(function () {
    var notificationTimer;

    if (props.open) {
      notificationTimer = setTimeout(function () {
        var element = document.getElementsByClassName('Notification')[0];
        (0, _Util.removeClassName)(element, 'open');
        props.setOpen(false);
      }, 5000);
    }

    return function () {
      if (notificationTimer) {
        clearTimeout(notificationTimer);
        if (props.hideNotification) props.hideNotification();
      }
    };
  }, [props.open]);
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: componentClass
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, _extends({}, attr, {
    className: "NotificationWindowInner",
    center: true
  }), children));
};

exports.Notification = Notification;